import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../../../hooks/useGraphQLMutation.hook';

export const ThirdPartyForm_Address_Create_Mutation = graphql(`
  mutation ThirdPartyForm_Address_Create(
    $address: AddressInput!
    $thirdPartyId: Id!
    $versionData: VersionDataInput
  ) {
    createThirdPartyAddress(
      address: $address
      multiAddressableId: $thirdPartyId
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useCreateThirdPartyAddressMutation = () =>
  useGraphQLMutation(ThirdPartyForm_Address_Create_Mutation);
